import { ToolbarDropdown } from "./Models/ToolbarDropdown";
import { ToolbarButton } from "./Models/ToolbarButton";
import { ToolbarItem } from "./Models/ToolbarItem";
import { ToolbarMenu } from "./Models/ToolbarMenu";
import { EventDispatcher } from "../Events/EventDispatcher";
import { IToolbarItem } from "./Models/IToolbarItem";

export class Toolbar {

    /**
     * dropdown click event
     */
    get onDropDownClick() {
        return this._onDropDownClick.asEvent();
    }
    private _onDropDownClick = new EventDispatcher<ToolbarDropdown, string>();

    /**
     * button click event
     */
    get onButtonClick() {
        return this._onButtonClick.asEvent();
    }
    private _onButtonClick = new EventDispatcher<ToolbarButton, string>();

    private items: Array<ToolbarItem> = [];

    public constructor(control: HTMLElement) {
        // parse all children
        for (let i = 0; i < control.children.length; i++) {
            let item = (control.children.item(i) as HTMLElement);
            // dropdown
            if (item.classList.contains("toolbar-dropdown")) {
                this.items.push(new ToolbarDropdown(item, this));
            }
            else if (item.classList.contains("toolbar-menu")) {
                this.items.push(new ToolbarMenu(item, this));
            }
            else if (item.classList.contains("toolbar-button")) {
                this.items.push(new ToolbarButton(item, this));
            }
        }
    }

    public dispatchDropDownClick(dropdown: ToolbarDropdown, value: string) {
        this._onDropDownClick.dispatch(dropdown, value);
    }

    public dispatchButtonClick(button: ToolbarButton, value: string) {
        this._onButtonClick.dispatch(button, value);
    }

    public getSelectedDropdownValue(dropdownId: string): string {
        for (let item of this.items) {
            if (item.id == dropdownId) {
                return (<ToolbarDropdown>item).getSelectedValue();
            }
        }
        return null;
    }

    public selectDropdownValue(dropdownId: string, value: string): void {
        for (let item of this.items) {
            if (item.id == dropdownId) {
                (<ToolbarDropdown>item).selectValue(value);
                break;
            }
        }
    }

    public getDropdown(dropdownId: string): ToolbarDropdown {
        for (let item of this.items) {
            if (item.id == dropdownId) {
                return (<ToolbarDropdown>item);
            }
        }
        return null;
    }

    public setButtonText(id: string, text: string) {
        for (let item of this.items) {
            if (item.id == id) {
                (<ToolbarButton>item).setText(text);
                break;
            }
        }
    }

    public enableItem(id: string, enable: boolean) {
        let item = this.findItemById(id);
        if (item) {
            item.enable(enable);
        }
    }

    public findItemById(id: string): IToolbarItem {
        for (let item of this.items) {
            let result = item.findItemById(id);
            if (result) {
                return result;
            }
        }
        return null;
    }
}
